import { enablePageScroll, disablePageScroll } from "scroll-lock";

function toggleMenu() {
  let button = $('.header-sticky__wrapper button.main');
  let menu = $('.header-mobmenu');
  let scrollableElement = document.querySelector('.header-mobmenu');
  let trigger = $('.header-mobmenu__button');
  let dropdown = $('.header-mobmenu__dropdown');
  let bg = $('.header-mobmenu__bg');
  let primary = $('.header__primary');
  button.on('click', function() {
    if (menu.hasClass('active')) {
      button.removeClass('active');
      primary.removeClass('active');
      bg.removeClass('active');
      enablePageScroll();
      menu.removeClass('active');
    } else {
      button.addClass('active');
      primary.addClass('active');
      bg.addClass('active');
      disablePageScroll(scrollableElement);
      menu.addClass('active');
    }
  });
  trigger.on('click', function() {
    trigger.not(this).parent().removeClass('active');
    trigger.not(this).parent().next().removeClass('active');
    $(this).parent().toggleClass('active');
    $(this).parent().next().toggleClass('active');
  });
  $(window).on('resize', function() {
    if ($(window).width() >= 1280 && button.hasClass('active')) {
      button.removeClass('active');
      menu.removeClass('active');
      primary.removeClass('active');
      trigger.removeClass('active');
      dropdown.removeClass('active');
      bg.removeClass('active');
      enablePageScroll();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key == 'Escape') {
      button.removeClass('active');
      menu.removeClass('active');
      primary.removeClass('active');
      trigger.removeClass('active');
      dropdown.removeClass('active');
      bg.removeClass('active');
      enablePageScroll();
    }
  });
}
toggleMenu();